jQuery(function( $ ) {

    var ua = window.navigator.userAgent;

        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {

    	$( '.elementor-invisible' ).removeClass( 'elementor-invisible' );
        }

        var trident = ua.indexOf('Trident/');
        if (trident > 0) {

    	$( '.elementor-invisible' ).removeClass( 'elementor-invisible' );
        }

        // other browser
        return false;

    // $( '.elementor-invisible' ).removeClass( 'elementor-invisible' );

});
